var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "h2",
                {
                  staticClass:
                    "font-semibold text-xl text-gray-800 leading-tight",
                },
                [_vm._v("\n            API Tokens\n        ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" },
          [
            _c("api-token-manager", {
              attrs: {
                tokens: _vm.tokens,
                "available-permissions": _vm.availablePermissions,
                "default-permissions": _vm.defaultPermissions,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }